import { render, staticRenderFns } from "./ProfileDlg.vue?vue&type=template&id=2719556b&"
import script from "./ProfileDlg.vue?vue&type=script&lang=js&"
export * from "./ProfileDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports